import { Distrolist } from './distrolist.types';
import { AssociatedCommunity } from './communities.types';
import { Event, Session } from './event.types';
import { Guest, GuestStatus, GuestType } from './guest.types';
import { MultiSessionPlusOneGuest, PlusOneGuest } from './plus-one.types';
import { QuestionResponse, TypedQuestion } from './question-response.types';

export interface SessionStatus {
  id: number;
  status: GuestStatus;
}

export enum CalendarProvider {
  GOOGLE = 'GOOGLE',
  OUTLOOK = 'OUTLOOK'
}

export interface EventForRSVPControl extends Omit<Event, 'preEventQuestions'> {
  preeventEnable: boolean;
  preEventQuestions: TypedQuestion[];
  calendarProvider: CalendarProvider;
  isEventWaitlisted: boolean;
  limitRegistration: boolean;
}

export interface GuestForRSVPControl {
  gid: string;
  userId?: number;
  eventId: number;
  email: string;
  firstName: string;
  lastName: string;
  status: GuestStatus;
  isAttended: boolean;
  zoomStatus: string;
  meetStatus: string;
  surveySubmittedAt?: string;
  surveyResponses?: QuestionResponse[];
  lastUpdatedAt: string;
  profilePictureUrl?: string;
  associatedDistrolists?: Distrolist[];
  associatedCommunities?: AssociatedCommunity[];
  guestType: GuestType;
  plusOnes: PlusOneGuest[];
}

export interface GuestDataForRSVPControl {
  guest: GuestForRSVPControl;
  event: EventForRSVPControl;
  sessionStatuses: SessionStatus[];
  /** Parent plus-ones - only present when viewing a session in a multi-session event */
  parentPlusOnes?: MultiSessionPlusOneGuest[];
}

export interface SessionAndStatus {
  session: Session;
  status: GuestStatus;
}

export interface SwapGuestState {
  guest?: Guest;
  status: GuestStatus;
}

export enum WaitlistAdjustmentOption {
  IncreaseCapacity = 'IncreaseCapacity',
  SwapWithOtherGuest = 'SwapWithOtherGuest',
  IncreaseCapacityWithPlusOnes = 'IncreaseCapacityWithPlusOnes'
}

export enum GuestActivityType {
  INVITED = 'INVITED',
  UNINVITED = 'UNINVITED',
  RSVP_CHANGED_TO_PENDING = 'RSVP_CHANGED_TO_PENDING',
  MARKED_AS_NOT_GOING = 'MARKED_AS_NOT_GOING',
  RSVP_AS_GOING = 'RSVP_AS_GOING',
  MARKED_AS_INCOMPLETE = 'MARKED_AS_INCOMPLETE',
  RSVP_AS_MAYBE = 'RSVP_AS_MAYBE',
  RSVP_AS_WAITLISTED = 'RSVP_AS_WAITLISTED',
  UNKNOWN = 'UNKNOWN'
}

export interface GuestActivity {
  id: string;
  type: GuestActivityType;
  title: string;
  datetime: string;
  attributionString: string | null;
}
